module.exports = __webpack_public_path__ + "img/appStore.e986eff7.jpeg";